// Core URLs
export const URL_LIST_VIEW_API = '/certifications/v2/listView';
export const URL_LIST_DATA_API = '/certifications/v2/listData';
export const URL_PREDEFINED_COMMENT_API =
  '/certifications/v2/getPredefinedComments';

// Sidepanel URLS
export const URL_SIDE_PANEL_SUMMARY_API =
  '/certifications/v2/certificationSummary';
export const URL_SIDE_PANEL_HISTORY_API =
  '/certifications/v2/items/auditHistory';
export const URL_SIDE_PANEL_PROGRESS_API =
  '/certifications/v2/items/fetchCertificationProgress';

// Tabs urls
export const URL_CERT_LIST_TABS_COUNT_API =
  '/certifications/v2/tabCountCertList';

// Line action URLs
export const URL_CANCEL_ACTION_API =
  '/api/certifications/v2/discontinuecertification';
// redirecting to certms
export const URL_REASSIGN_ACTION_API =
  '/certifications/v2/reassignCertification';
export const URL_EMAIL_HISTORY_API = '/api/certifications/v2/emailHistory';
export const URL_NOTIFY_ACTION_API =
  '/api/certifications/v2/items/sendNotifyEmail';

// refresh api
export const URL_CERT_LIST_REFRESH_PROGRESS =
  '/certifications/v2/campaignProgressRefresh';
